<template>
  <div class="select-pay-way">
    <div class="select-pay-way-content">
      <ul class="payway-select-container">
        <li
          class="select-items select-items-wrapper j-select-payType"
          :active="
            payType.f_pay_type == selectedPaytpe.f_pay_type &&
            payType.pay_type == selectedPaytpe.pay_type
          "
          :class="{
            active:
              payType.f_pay_type == selectedPaytpe.f_pay_type &&
              payType.pay_type == selectedPaytpe.pay_type,
            hasOtherContent:
              isBank(payType.f_pay_type, payType.pay_type) ||
              hasQuickCard(
                payType.f_pay_type,
                payType.pay_type,
                payType.user_infos
              ) ||
              canSelectMoney(payType.f_pay_type, payType.pay_type) ||
              isCoinsPay(payType) ||
              isCreditCard(payType) ||
              showPaypalAgreement(payType)
          }"
          :pointValue="payType.name"
          v-for="(payType, index) in foldPayTypes"
          :key="index"
          v-if="!isJpPnsHide(payType.pay_type)"
        >
          <div class="active-shade"></div>
          <div
            class="pay-type-parent"
            :class="{
              hasOtherContent:
                isBank(payType.f_pay_type, payType.pay_type) ||
                hasQuickCard(
                  payType.f_pay_type,
                  payType.pay_type,
                  payType.user_infos
                ) ||
                canSelectMoney(payType.f_pay_type, payType.pay_type) ||
                isCoinsPay(payType) ||
                isCreditCard(payType) ||
                showPaypalAgreement(payType)
            }"
            @click="
              selectPayType(
                payType,
                payType.child ? payType.child.length : 0,
                payType.f_pay_type + index,
                true
              )
            "
          >
            <div class="pay-way-ico-wrap">
              <img
                :src="
                  getCurPayWayIcon(
                    payType.f_pay_type,
                    payType.pay_type,
                    childChannel.child_id
                  )
                "
                class="pay-way-icon"
                alt=""
              />
            </div>
            <div class="name-tag-box">
              <div class="channel-name">
                <p class="channel-name-text">
                  {{ channelNameText(payType, childChannel) }}
                </p>
                <em class="channel-name-shade"></em>
              </div>
              <div class="tag-box">
                <span
                  class="type-lasted"
                  v-if="
                    !isHideLastPayWayFunc &&
                    lastPayType &&
                    payType.f_pay_type == lastPayType.f_pay_type &&
                    payType.pay_type == lastPayType.pay_type &&
                    (payType.child ? !payType.child.length : true)
                  "
                  >{{ letter.lastSelectTag }}</span
                >
                <span
                  class="type-discount"
                  v-if="
                    payType.price_list.length > 0 &&
                    payType.price_list[0].EXTRA_RATIO >= 0.01 &&
                    payType.pay_type !== 'virtual_account' &&
                    !hidePaytypeDisountTag
                  "
                >
                  {{ letter.gainPlus }}
                  {{ ~~(payType.price_list[0].EXTRA_RATIO * 100) }}%
                </span>
                <!-- 银行汇款渠道需要显示最高加码 -->
                <span
                  class="type-discount"
                  v-if="
                    payType.price_list.length > 0 &&
                    payType.price_list[0].EXTRA_RATIO >= 0.01 &&
                    payType.pay_type == 'virtual_account' &&
                    !hidePaytypeDisountTag
                  "
                >
                  {{ letter.gainMostPlus }}
                  {{ ~~(getMostPlus(payType.price_list) * 100) }}%
                </span>
                <span
                  v-if="isFuntapGame && payType.pay_type === 'funtap_9pay'"
                  class="type-discount"
                >
                  Hoàn 5%
                </span>
                <span
                  class="type-discount"
                  v-if="
                    payType.child &&
                    payType.child.length &&
                    childChannel &&
                    childChannel.child_id
                      ? +childChannel.coupon
                      : +payType.coupon
                  "
                >
                  {{ letter.couponCanUseQuan }}
                </span>
              </div>
            </div>
            <Icon
              class="paytype-more-icon"
              pointClass="j-toogle-child-payType"
              v-if="payType.child && payType.child.length"
              :class="{
                active:
                  payType.child &&
                  payType.child.length &&
                  payTypeSeemIdentify[payType.f_pay_type + index]
              }"
            ></Icon>
            <Payment
              v-if="
                canSelectMoney(payType.f_pay_type, payType.pay_type) && !isCoins
              "
              :languages="letter"
              :curPayType="curPayType"
              :curProduct="curProduct"
              :curPrice="curPrice"
              :pricesList="curPricesList"
              @showError="showError"
              @selectPayMent="selectPayMent"
            ></Payment>
            <bank-pay
              v-if="
                isBank(payType.f_pay_type, payType.pay_type) &&
                isBank(selectedPaytpe.f_pay_type, selectedPaytpe.pay_type)
              "
              :isCoins="isCoins"
              :game-id="gameId"
              :role-id="roleId"
              :role-name="roleName"
              :languages="letter"
              :server-id="ourServerId"
              :cur-pay-type="curPayType"
              @showError="showError"
            ></bank-pay>
            <quick-pay-card
              v-if="
                hasQuickCard(
                  payType.f_pay_type,
                  payType.pay_type,
                  payType.user_infos
                )
              "
              :languages="letter"
              :cur-pay-type="curPayType"
              :card-infos="payType.user_infos"
              :cur-card="curCard"
              @selectCard="selectCard"
              @showError="showError"
              @deleteCurPayTypeCard="deleteCurPayTypeCard"
            ></quick-pay-card>
            <coins-payment
              v-if="isCoinsPay(payType)"
              :curLocationVal="curLocationVal"
              :curCoins="curCoins"
              :curPayType="curPayType"
              :discountTransMount="discountTransMount"
            ></coins-payment>
            <credit-card
              v-if="isCreditCard(payType)"
              :curLocationVal="curLocationVal"
              :discountTransMount="discountTransMount"
              :curCoins="curCoins"
              :isCoins="isCoins"
              :language="letter"
              :curPayType="curPayType"
            ></credit-card>
            <paypal-direct
              v-if="showPaypalAgreement(payType)"
              :language="letter"
            ></paypal-direct>
          </div>
        </li>
      </ul>
      <p
        class="fold j-click-more-channel"
        v-show="payTypes.length > 3 && fold"
        @click="changeFoldState"
      >
        {{ letter.storeLookMore }}<span class="icon"></span>
      </p>
      <p class="no-pay-way" v-if="foldPayTypes.length <= 0">
        {{ letter.noPayWay }}
      </p>
    </div>
    <PopupWindow
      @onCancel="jiamaPopup = false"
      @onConfirm="jiamaPopup = false"
      type="tips"
      textAlign="left"
      :title="' '"
      v-if="jiamaPopup"
      :languages="letter"
      :content="jiamaContent"
    ></PopupWindow>
  </div>
</template>

<script>
import VerticalToggle from '@utiles/vertical-toggle';
import { RES_HOST, PAYTYPE_ICON_URL } from '@utiles/officialStore';
import BankPay from '@components/officialStore/paytype/BankPayway.vue';
import QuickPayCard from '@components/officialStore/paytype/QuickPayCard.vue';
import Payment from '@components/officialStore/paytype/Payment.vue';
import BankPayment from '@components/officialStore/paytype/BankPayment.vue';
import PaypalDirect from '@components/officialStore/paytype/PaypalDirect.vue';
import CreditCard from '@components/officialStore/paytype/CreditCard.vue';
import { mapState, mapGetters } from 'vuex';
import CoinsPayment from './CoinsPayment.vue';
import { UPDATE_HIDE_SUBMIT } from '@store/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
import gsOperate from '@mixins/officialStore/gsOperate';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isHideLastPayWay } from '@utiles/hideLastPayWay';

export default {
  mixins: [gsOperate],
  props: [
    'allPayTypes',
    'curPayType',
    'isFuntapGame',
    'gameId',
    'lastPayType',
    'roleId',
    'roleName',
    'ourServerId',
    'curCard',
    'isReload',
    'curProduct',
    'pricesList',
    'curPrice',
    'curLocationVal',
    'curCoins',
    'isCoins',
    'discountTransMount'
  ],
  data() {
    return {
      ICON_URI: RES_HOST + 'commonImg/store/',
      selectedPaytpe: this.curPayType,
      jiamaPopup: false,
      childChannel: {},
      fold: false,
      hadClickFold: false,
      limitAllPayTypes: [],
      payTypes: [],
      isAutoSelect: false
    };
  },
  watch: {
    curPayType() {
      this.selectedPaytpe = this.curPayType;
    },
    curLocationVal() {
      this.hadClickFold = false;
    },
    allPayTypes: {
      deep: true,
      immediate: true,
      handler() {
        this.filterLimitAllPayTypes();
        this.filterPayTypes();
        this.autoSelectPaytype();
      }
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isCart: state => state.cart.isCart,
      cartList: state => state.cart.cartList,
      loginType: state => state.login.loginType,
      isWhite: state => state.white,
      isSecurity: state => state.security
    }),
    ...mapGetters([
      'isJpPlatform',
      'getPointPayChannelName',
      'getCoinsName',
      'cartTotalPrice'
    ]),
    foldPayTypes: {
      get: function () {
        if (this.fold) {
          if (this.payTypes.length <= 3) {
            return this.payTypes;
          }
          let newArr = [];
          for (let i = 0; i < 3; i++) {
            newArr.push(this.payTypes[i]);
          }
          return newArr;
        }
        return this.payTypes;
      },
      set: function (val) {
        this.foldPayTypes = val;
      }
    },
    payTypeSeemIdentify() {
      const payTypeSeemIdentify = {};
      for (let i = 0, length = this.limitAllPayTypes.length; i < length; i++) {
        payTypeSeemIdentify[this.limitAllPayTypes[i].f_pay_type + i] = false;
      }
      return payTypeSeemIdentify;
    },
    jiamaContent() {
      return this.letter.jiamaInfo.replace(/\n/g, '</br>');
    },
    hidePaytypeDisountTag() {
      return this.$store.getters.hidePaytypeDisountTag;
    },
    isJpPnsHide() {
      // blancozone域名，不分游戏，不用跳转,支付渠道是日本地区的时候，隐藏指定渠道
      // 20240821 除了pnsofficial.com和window.atob('MzdnYW1lcy5jb20=')域名,隐藏指定渠道
      const hideWay = [
        'JP-BANK_TRANSFER-PAYEASY',
        'JP-WALLET-LINEPAY',
        'JP-OTC'
      ];
      const showDomain = ['pnsofficial.com', window.atob('MzdnYW1lcy5jb20=')];
      return function (payType) {
        return (
          this.curLocationVal === 'JP' &&
          !showDomain.includes(globalConfig.getMainHost()) &&
          hideWay.includes(payType)
        );
      };
    },
    isHideLastPayWayFunc() {
      return isHideLastPayWay(this.gameId, this.curLocationVal);
    }
  },
  created() {
    // 购物车-第一个渠道定价表不存在，自动帮他找一个有定价表的渠道
    // 没有渠道的话就不选了
    if (this.payTypes.length <= 0) {
      return;
    }
    if (this.isCart && !this.checkCartProductHasPrice(this.payTypes[0])) {
      this.autoSelectHasPricePaytype();
      return;
    }
    this.selectFirstPayType();
  },
  methods: {
    autoSelectPaytype() {
      if (this.isReload && this.payTypes.length > 0) {
        if (this.isCart && !this.checkCartProductHasPrice(this.payTypes[0])) {
          this.autoSelectHasPricePaytype();
          return;
        }
        this.selectFirstPayType();
        this.$emit('resetReload');
      }
    },
    filterLimitAllPayTypes() {
      /**
       * 当交易金额低于最低可用金额时，或高于最高可用金额时，该渠道隐藏
       * limit_bottom_money和limit_top_money不为0的时候才是有效
       * 只对全球平台处理非平台币商品处理
       */
      if (this.isJpPlatform || this.isCoins) {
        this.limitAllPayTypes = this.allPayTypes;
        return;
      }
      const newAllPayType = [];
      let curUserNeedPayMoney = '';
      if (this.isCart) {
        // 购物车支付金额
        curUserNeedPayMoney = this.cartTotalPrice;
      } else {
        // 单商品购买支付金额
        curUserNeedPayMoney = this.curPrice?.TRANS_AMOUNT;
      }
      curUserNeedPayMoney = Number(curUserNeedPayMoney || 0);
      for (let i = 0, len = this.allPayTypes.length; i < len; i++) {
        let bottomPriceFormat = this.allPayTypes[i].limit_bottom_money || 0;
        let topPriceFormat = this.allPayTypes[i].limit_top_money || 0;
        bottomPriceFormat = Number(bottomPriceFormat);
        topPriceFormat = Number(topPriceFormat);
        if (
          (curUserNeedPayMoney < bottomPriceFormat &&
            bottomPriceFormat !== 0) ||
          (curUserNeedPayMoney > topPriceFormat && topPriceFormat !== 0)
        ) {
          continue;
        } else {
          newAllPayType.push(this.allPayTypes[i]);
        }
      }
      // 如果没有渠道则隐藏提单
      this.$store.commit(UPDATE_HIDE_SUBMIT, newAllPayType.length <= 0);
      this.limitAllPayTypes = newAllPayType;
    },
    filterPayTypes() {
      let typs = [];
      for (let i = 0, len = this.limitAllPayTypes.length; i < len; i++) {
        if (this.limitAllPayTypes[i].price_list.length > 0) {
          this.limitAllPayTypes[i]._index = i;
          // 如果上次储值渠道，就置顶
          if (
            !isHideLastPayWay(this.gameId, this.curLocationVal) &&
            this.limitAllPayTypes[i].f_pay_type ==
              this.lastPayType.f_pay_type &&
            this.limitAllPayTypes[i].pay_type == this.lastPayType.pay_type
          ) {
            typs.unshift(this.limitAllPayTypes[i]);
          } else {
            typs.push(this.limitAllPayTypes[i]);
          }
        }
      }
      /**
       * 由于监听了curPrice在计算属性中filterAllPayTypes被用到，选择渠道会更新curPrice重新触发filterAllPayTypes，
       * 需要用hadClickFold记录当前地区渠道是否被展开过,否则每次选完渠道都会折叠起渠道
       */
      if (this.hadClickFold) {
        // 如果当前地区渠道被展开过，则选择当前地区渠道后保持展开
        this.fold = false;
      } else {
        this.fold = typs.length > 3;
      }
      this.payTypes = typs;
    },
    channelNameText(payType, childChannel) {
      if (payType.f_pay_type === this.getPointPayChannelName) {
        return this.getCoinsName;
      }
      return payType.child &&
        payType.child.length &&
        childChannel &&
        childChannel.child_id
        ? childChannel.child_name
        : payType.name;
    },
    changeFoldState() {
      this.hadClickFold = true;
      this.fold = !this.fold;
      clickButton({
        btnName: 'more_channels',
        locationKey: locationType.paytypeSection
      });
    },
    selectPayMent(payment) {
      this.$emit('selectPayMent', payment);
    },
    checkCartProductHasPrice(payType) {
      // 购物车切换渠道之前，判断定价表是否存在，不存在则不给切渠道
      let cartPriceList = this.cartList
        .map(item => {
          return item.AMOUNT_LEVEL;
        })
        .filter((item, index, arr) => arr.indexOf(item, 0) === index);
      let paytypeItem = this.$store.state.allPaytypePriceMap.find(
        item =>
          item.f_pay_type == payType.f_pay_type &&
          item.pay_type == payType.pay_type
      );
      let isInclude = true;
      cartPriceList.forEach(item => {
        if (!paytypeItem.priceList.includes(item)) {
          isInclude = false;
        }
      });
      return isInclude;
    },
    selectPayType(payType, hasChildPayTyp, targetParentKey, isHandSelect) {
      if (this.isCart && !this.checkCartProductHasPrice(payType)) {
        this.$globalTip({
          title: this.letter.tips,
          content: this.letter.paytype_limit,
          confirm: this.letter.onestore_subscribe_confirm
        });
        return;
      }
      this.selectedPaytpe = payType;

      if (hasChildPayTyp) {
        this.controlChildSeem(targetParentKey);
      } else {
        if (isHandSelect) {
          payType.isAutoSelect = false;
        } else {
          payType.isAutoSelect = this.isAutoSelect;
        }
        this.$emit('selectPayWay', payType);
        this.childChannel = {};
      }
    },
    controlChildSeem(targetParentKey) {
      for (let i = 0, length = this.limitAllPayTypes.length; i < length; i++) {
        this.limitAllPayTypes[i].f_pay_type + i !== targetParentKey &&
          (this.payTypeSeemIdentify[
            this.limitAllPayTypes[i].f_pay_type + i
          ] = false);
      }
      this.$set(
        this.payTypeSeemIdentify,
        targetParentKey,
        !this.payTypeSeemIdentify[targetParentKey]
      );
    },
    selectChildPayType(payType, childIndex, pindex, childPayType) {
      // 选了哪个子渠道
      payType['selectChildIndex'] = childIndex;
      payType.isAutoSelect = this.isAutoSelect;
      this.$emit('selectPayWay', payType);
      this.payTypeSeemIdentify[pindex] = false;
      this.$nextTick(() => {
        this.childChannel = childPayType;
      });
    },
    openJiamaPopup() {
      this.jiamaPopup = true;
    },
    // TOTO，活动时间：3月22日晚上23:00至4月1日晚上23:00，
    // 结束后之后删除该代码
    iconReplace(fpt, pt, imgUrl) {
      const curTime = new Date().getTime();
      const startTime = new Date('2023/3/22 23:00:00').getTime();
      const endTime = new Date('2023/4/1 23:00:00').getTime();
      // const applyGame = [191, 211].includes(+this.gameId);

      if (
        fpt === 'payer_max' &&
        pt === 'JP-BANK_TRANSFER-PAYEASY' &&
        // applyGame &&
        curTime > startTime &&
        curTime < endTime
      ) {
        return imgUrl.replace(
          'JP-BANK_TRANSFER-PAYEASY',
          'JP-BANK_TRANSFER-PAYEASY-TEMP'
        );
      }

      if (
        fpt === 'payer_max' &&
        pt === 'KR-WALLET-KAKAOPAY' &&
        // applyGame &&
        curTime > startTime &&
        curTime < endTime
      ) {
        return imgUrl.replace('KR-WALLET-KAKAOPAY', 'KR-WALLET-KAKAOPAY-TEMP');
      }
      return imgUrl;
    },
    getCurPayWayIcon(fpt, pt, cid) {
      // 特殊处理代币先用游戏ico，渠道名称：日本平台叫points_pay，全球平台叫user_balance_pay
      const channelName = this.isJpPlatform ? 'points_pay' : 'user_balance_pay';
      if (fpt === channelName && pt === channelName) {
        return `${PAYTYPE_ICON_URL}${fpt}/gameid_${this.gameId}_${pt}.png`;
      }

      const imgUrl = `${PAYTYPE_ICON_URL}${fpt}/${pt}${
        cid &&
        fpt == this.selectedPaytpe.f_pay_type &&
        pt == this.selectedPaytpe.pay_type
          ? `/${cid}`
          : ''
      }.png`;

      return this.iconReplace(fpt, pt, imgUrl);
    },
    isBank(fpt, pt) {
      return fpt == 'virtual_account' && pt == 'virtual_account';
    },
    isCoinsPay(payType) {
      // 代币消费：接口返回的的父渠道f_pay_type和子渠道pay_type在全球叫：user_balance_pay；在日本叫points_pay
      const coinsPayName = this.isJpPlatform
        ? 'points_pay'
        : 'user_balance_pay';
      return (
        payType &&
        payType.f_pay_type === coinsPayName &&
        payType.pay_type === coinsPayName &&
        payType.f_pay_type == this.selectedPaytpe.f_pay_type &&
        payType.pay_type == this.selectedPaytpe.pay_type
      );
    },
    isCreditCard(payType) {
      return (
        payType &&
        payType.f_pay_type === 'credit_card' &&
        payType.f_pay_type == this.selectedPaytpe.f_pay_type
      );
    },
    showError(err) {
      this.$emit('showError', err);
    },
    selectCard(card) {
      this.$emit('selectCard', card);
    },
    deleteCurPayTypeCard(keyValue) {
      this.$emit('deleteCurPayTypeCard', keyValue);
    },
    showPaypalAgreement(paytype) {
      return (
        paytype &&
        paytype.f_pay_type === 'paypal_api' &&
        paytype.pay_type === 'paypal_agreement' &&
        paytype.f_pay_type == this.selectedPaytpe.f_pay_type &&
        paytype.pay_type == this.selectedPaytpe.pay_type &&
        +this.isWhite &&
        +this.isSecurity
      );
    },
    hasQuickCard(fpt, pt, userInfo) {
      // 2023.06.06:亨哲：checkout不显示卡信息
      return (
        fpt == this.selectedPaytpe.f_pay_type &&
        pt == this.selectedPaytpe.pay_type &&
        fpt != 'checkout' &&
        userInfo &&
        userInfo.length > 0
      );
    },
    selectFirstPayType() {
      this.isAutoSelect = true;
      this.selectPayType(this.payTypes[0]);
    },
    getMostPlus(list) {
      let res = 0;
      list.map(item => {
        if (+item.EXTRA_RATIO > res) {
          res = +item.EXTRA_RATIO;
        }
      });
      return res;
    },
    canSelectMoney(fpt, pt) {
      // loginType = 2 | 3时是大R支付，可以选择任意金额储值
      return (
        fpt == this.selectedPaytpe?.f_pay_type &&
        pt == this.selectedPaytpe?.pay_type &&
        !this.isCart &&
        (this.curPayType?.fixed == 1 ||
          this?.loginType == 2 ||
          this?.loginType == 3)
      );
    },
    autoSelectHasPricePaytype() {
      let paytypeLength = this.payTypes.length;
      for (let i = 1; i < paytypeLength; i++) {
        if (this.checkCartProductHasPrice(this.payTypes[i])) {
          this.selectPayType(this.payTypes[i]);
          if (i >= 3) {
            this.fold = false;
          }
          break;
        }
      }
      // 全部渠道都没有符合定价表，切换地区到global，每个渠道都至少有global地区的渠道，所以不会有这种情况
      // if (hasSelectIndex === 0) {
      //   alert('当前地区的全部渠道定价表不存在');
      // }
    }
  },
  components: {
    VerticalToggle,
    BankPay,
    QuickPayCard,
    Payment,
    BankPayment,
    CoinsPayment,
    CreditCard,
    PaypalDirect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.select-pay-way {
  display: block;
  margin: 0 auto 24px;
  width: 100%;
}
.type-lasted {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 12px;
  padding: 0 8px;
  border: 1px solid var(--channel-tag-border);
  background-color: var(--channel-tag-bg);
  line-height: 26px;
  text-align: center;
  font-size: 20px;
  color: var(--channel-tag-text);
}
.channel-name {
  display: inline-block;
  position: relative;
  min-height: 0 !important;
  color: var(--channel-name);
  word-break: break-word;
  &-text {
    position: relative;
    z-index: 2;
  }
  &-shade {
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 203px;
    height: 13px;
    background: url($pnsImg + 'name-shade.png') no-repeat top;
    background-size: cover;
  }
}
.fold {
  margin-top: 20px;
  text-align: center;
  font-size: 24px;
  color: var(--channel-more);
  .icon {
    display: inline-block;
    margin-left: 15px;
    @psetbg ('paytype-more.png');
  }
}
.no-pay-way {
  margin-top: 20px;
  text-align: left;
  font-size: 24px;
  color: var(--channel-more);
}
.select-items {
  .active-shade {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    background-size: cover;
    transform: translate(-50%, -50%);
    @psetbg ('active-shade.png',false,false);
  }
  &.active {
    .active-shade {
      display: block;
    }
  }
  &:last-child {
    .pay-type-parent {
      border-bottom: none;
    }
  }
}
</style>
